import React from 'react'
import { RaisedInformallyIcon } from './components/RaisedInformallyIcon'
import { LearnMoreCard } from 'pages/learn-more/components/LearnMoreCard'
import { SearchCategoryCard } from 'pages/learn-more/components/SearchCategoryCard'
import { AdvisoryClientIcon } from 'pages/learn-more/components/AdvisoryClientIcon'
import { LegalAdviceIcon } from 'pages/learn-more/components/LegalAdviceIcon'
import { Step1BookingCategoryDummy } from 'pages/learn-more/components/Step1BookingCategoryDummy'
import { MemberProfileShort } from 'cwp-components/CWP Sections/MemberProfile/MemberProfileShort'
import { DUMMY_PROFILES } from 'pages/learn-more/data/DUMMY_PROFILES'
import { DEFAULT_SERVICES } from 'pages/learn-more/data/DEFAULT_SERVICES'
import GreenCheck from 'assets/green-check.svg'

const bodyTextStyles =
  'text-xs md:text-sm lg:text-base 3xl:text-[18px] max-md:text-center md:text-justify font-normal leading-[20px] tracking-[0.4px] text-[#405985] md:max-w-full '
const profileScaleStyles = 'relative transform origin-top scale-[0.7] sm:scale-75 md:scale-90 lg:scale-100'

interface LearnMorePageProps { }

const LearnMorePage = (props: LearnMorePageProps) => {
  return (
    <div className='py-12 md:!py-24'>
      <div className='h-fit bg-gradient-to-b from-[rgba(255,255,255,1)] to-[rgba(101,194,215,0.04)] '>
        <div className="w-full max-w-[780px] relative">
          <div className='flex flex-col lg:relative'>
            <div className='bg-[#001A3D] p-8 pb-20 w-[92vw] sm:w-[90vw] lg:w-[800px] xl:w-[1010px] 2xl:w-[1143px] 3xl:w-[1543px] lg:pr-60 md:p-20 rounded-tr-[20px] rounded-br-[20px] shadow-[4px_4px_200px_0px_rgba(0,0,0,0.3)]'>
              <h1 className='text-lg md:text-[24px] lg:text-[32px] 2xl:text-[40px] font-bold text-white leading-8 tracking-[0.4px]'>
                We're here to help you in your legal needs
              </h1>
              <div className='space-y-[20px] pt-10 lg:pt-[100px]'>
                <p className='text-xs md:text-sm lg:text-base 3xl:text-[18px] font-normal tracking-wider leading-4 md:leading-8 md:font-medium text-white'>
                  Find a Lawyer is a free service to help you find and select a
                  lawyer or firm to help you with a legal need. It also provides the
                  ability to schedule initial consultation appointments with your
                  selected lawyer remotely.
                </p>
                <p className='text-xs md:text-sm lg:text-base 3xl:text-[18px] font-normal tracking-wider leading-4 md:leading-8 md:font-medium text-white'>
                  Here, we provide additional information on how you can use this
                  service and how it works to assist your understanding on how to
                  best use the service. This includes how we generate, rank, and
                  display search results based on your use of the service.
                </p>
              </div>
            </div>
            <div className='z-[1] flex justify-center w-screen lg:w-full -mt-14 lg:absolute lg:top-52 lg:left-[420px] xl:top-[155px] xl:left-[690px] 2xl:left-[800px] 3xl:left-[1250px] 3xl:top-[130px]'>
              <div className='text-white bg-[#D0E2FA] rounded-lg p-5 border-2 border-[rgba(255, 255, 255, 0.12)] shadow-[4px_4px_200px_0px_rgba(0,0,0,0.3)]'>
                <h3 className='text-lg font-medium mb-4 lg:mb-5 text-[#001A3D]'>
                  Service information
                </h3>
                <ul className='lg:text-base text-xs font-normal space-y-[20px] text-[#001A3D]'>
                  {DEFAULT_SERVICES.map((service) => (
                    <li className='flex items-center gap-2'>
                      <img
                        className='w-4 h-4'
                        src={GreenCheck}
                        alt=''
                      />{' '}
                      {service}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='bg-[radial-gradient(180%_90%_at_1%_90%,rgba(45,204,239,0.25)_0%,rgba(208,226,250,0.1)_100%)]'>
        <div className='pt-20'>
          <LearnMoreCard title='How you search for lawyers and firms'>
            <div className='flex flex-col md:grid md:grid-cols-2 gap-8 md:gap-12 justify-between xl:items-center'>
              <p className={bodyTextStyles}>
                You can use the text-based search box on the home page to enter
                keywords or topics for your search, e.g. divorce or
                conveyancing. Alternatively, you can describe your problem, for
                example, ’I want to ask my landlord to make an urgent repair’,
                or ‘Have I been unfairly dismissed from my job?’. This
                information will be used to search our comprehensive database of
                lawyers and firms. We may use artificial intelligence to
                understand your information and match it with the lawyers and
                firms in our database, to find you the best possible legal
                advice for your problem.
              </p>
              <div className='flex flex-col items-center justify-center gap-2'>
                <p className='w-[280px] md:w-[220px] lg:w-[320px] text-center mb-2 text-xs text-[#405985]'>
                  Our search box for legal help, showing an example of how to
                  use it.
                </p>
                <div className='max-w-[333px] border border-[#001A3D] rounded-[20px] p-4 shadow-[-0.2px_-0.2px_30px_0px_rgba(190,190,223,0.5),_0.2px_0.2px_30px_0px_rgba(190,190,223,0.5)]'>
                  <p className='text-xs md:text-sm font-medium text-[#586885] text-justify'>
                    I know how to sell shares in a LTD company - I know this
                    procedure. Advise how I can sell LLP - Limited Liability
                    Partnership VAT registred? Designated members will resign.
                    How I can tell HMRC that I am no longer responsible for LLP
                    business - that there are new members.
                  </p>
                </div>
              </div>
            </div>
          </LearnMoreCard>
        </div>
      </div>

      <div className='bg-[radial-gradient(180%_190%_at_0%_10%,rgba(45,204,239,0.25)_0%,rgba(208,226,250,0.01)_100%)]'>
        <div className=''>
          <LearnMoreCard title='How we generate search results'>
            <div className='flex flex-col md:grid md:grid-cols-[1fr_1fr] gap-8 md:gap-12 justify-between items-center'>
              <div className='flex lg:items-center px-6 md:px-0'>
                <div className="flex flex-col lg:flex-row relative">
                  <div className="relative">
                    <SearchCategoryCard
                      titleText="Raised informally"
                      bodyText="I, or other party, have raised the issue directly with someone involved."
                      icon={<RaisedInformallyIcon />}
                    />
                  </div>
                  <div className="relative z-10 -mt-7 ml-4 lg:mt-0 lg:-ml-18">
                    <SearchCategoryCard
                      titleText="Advisory client"
                      bodyText="There is no issue or formal case at the moment, but I would like information on a particular matter."
                      icon={<AdvisoryClientIcon />}
                    />
                  </div>
                  <div className="relative z-20 -mt-3 ml-8 lg:mt-0 lg:-ml-18">
                    <SearchCategoryCard
                      titleText="Legal advice"
                      bodyText="Legal advice is where someone interprets and applies the law to a specific circumstance(s)."
                      icon={<LegalAdviceIcon />}
                    />
                  </div>
                </div>
              </div>
              <p className={bodyTextStyles}>
                Results are generated automatically, based on your search as
                well as any preferences you have applied to your account. They
                can be further refined by using our Find a Lawyer Intelligence
                service. When you input a keyword, topic, or description of your
                legal problem into the text-based search bar, our system will
                search for lawyers whose expertise matches the information in
                your search. The results are further filtered or refined based
                on any additional information you input via the Find a Lawyer
                Intelligence, and the lawyers’ information on our database.
              </p>
            </div>
          </LearnMoreCard>
        </div>
      </div>

      <div className='bg-[radial-gradient(180%_90%_at_0%_10%,rgba(45,204,239,0.15)_0%,rgba(208,226,250,0.01)_100%)]'>
        <LearnMoreCard title='How Expanded Search works'>
          <div className='flex flex-col gap-8 justify-between'>
            <p className={bodyTextStyles}>
              The Expanded Search is an automated, generative AI function that
              helps expand the context and number of words used to describe your
              legal query. The generative AI understanding the words you
              originally inputted into the text search box to create a more
              descriptive text description of your legal query up to 150 words.
              This is used to improve our proprietary law search capabilities to
              correctly identify the areas of English law that could be relevant
              to your legal query and, therefore, bring you the best and most
              relevant lawyer recommendations.
            </p>
            <div className='flex flex-col items-center justify-center'>
              <p className='text-center text-xs md:text-sm font-bold text-[#093269] md:mb-4 mb-3'>
                We have expanded on what you have told us.
              </p>
              <div className='max-w-[280px] md:max-w-[998px] border border-[#9FB7D7] rounded-md p-4 md:p-6 shadow-[1px_1px_10px_0px_rgba(0,0,0,0.12)]'>
                <div className='rounded-lg bg-[#F4F4F4] p-4 flex justify-between border border-[#E1E1E1]'>
                  <p className='text-xs md:text-sm font-normal text-[#586885] text-justify w-[98%] pr-2'>
                    I am looking to modify the existing custody arrangements
                    because of recent changes in my child’s living situation
                    that I believe are directly affecting their overall
                    well-being. Since these changes have occurred, I feel that
                    the current agreement no longer fits my child’s needs,
                    particularly in terms of visitation and the time spent with
                    each parent. However, the other parent strongly disagrees
                    with my assessment and feels that there is no need to make
                    any adjustments to the existing schedule. This disagreement
                    has caused conflict between us, as we both have differing
                    views on what is truly in the best interest of our child.
                    Furthermore, financial support has become another point of
                    contention, as the current arrangement doesn’t seem to
                    reflect the changes in our circumstances. I’m concerned that
                    the situation, if left unresolved, will negatively impact my
                    child, and I need guidance on how to approach these legal
                    disputes and ensure that their needs are prioritised.
                    <span className='text-[#37A2BA]'>|</span>
                  </p>
                  <svg
                    width='6'
                    height='100'
                    viewBox='0 0 6 104'
                    xmlns='http://www.w3.org/2000/svg'
                    className='w-1 md:w-2'
                  >
                    <line
                      x1='3'
                      y1='4'
                      x2='3'
                      y2='96'
                      stroke='#e1e1e1'
                      stroke-width='6'
                      strokeLinecap='round'
                    />
                  </svg>
                </div>
                <div className='flex flex-row max-[492px]:flex-col justify-end items-center mt-4'>
                  <p className='text-[10px] md:text-sm font-light text-[#586885] mr-4'>
                    Directly edit the text if inaccurate or click 'retry' to
                    automatically redraft.
                  </p>
                  <button className='ml-auto sm:ml-0 mt-2 sm:mt-0 disabled cursor-not-allowed !px-1 !py-1 text-[10px] md:text-sm btn-default text-[#1C7D93] w-[80px] md:w-[140px]'>
                    Sign in to retry
                  </button>
                </div>
              </div>
            </div>
          </div>
        </LearnMoreCard>
      </div>

      <LearnMoreCard title='How we rank and display profiles'>
        <div className='flex flex-col xl:grid xl:grid-cols-[1fr_1fr] gap-8 lg:gap-12 justify-between xl:items-center'>
          <p className={bodyTextStyles}>
            Profiles displayed on the Find a Lawyer results page are ranked by
            their relevance to the search term inputs and your preferences.
            Where profiles are identified by keyword, topic, or other
            information provided by you, they are included in the results. If
            the you then add more preferences to your search, this will filter
            or reduce the number of relevant profiles selected from our
            database. These profiles are displayed on a hierarchical basis with
            premium (purple) profiles displaying first or highest, then standard
            (green) second or below premium, and then basic (blue) below
            standard profiles. Should relevant profiles not include a
            hierarchical tier, they will not be included in the results.
          </p>
          <div className='relative flex justify-center lg:flex-row'>
            <div className="h-[500px] sm:h-fit lg:flex lg:flex-row">
              <div className={profileScaleStyles}>
                <MemberProfileShort profile={DUMMY_PROFILES[0]} disableViewButton />
              </div>
              <div className={`${profileScaleStyles} z-10 -mt-[340px] ml-12 lg:mt-0 lg:-ml-9`}>
                <MemberProfileShort profile={DUMMY_PROFILES[1]} disableViewButton />
              </div>
              <div className={`${profileScaleStyles} z-20 -mt-[340px] ml-24 lg:mt-0 lg:-ml-9`}>
                <MemberProfileShort profile={DUMMY_PROFILES[2]} disableViewButton />
              </div>
            </div>
          </div>
        </div>
      </LearnMoreCard>

      <LearnMoreCard title='How to make a booking' withArrow={false}>
        <div className='flex flex-col lg:grid lg:grid-cols-[1fr_1fr] gap-8 lg:gap-12 justify-between xl:items-center'>
          <p className={bodyTextStyles}>
            You can make a booking via the Find a Lawyer service once you have
            selected a lawyer profile from your search results. You start by
            selecting the type of booking you would like to make (Document
            Review or Legal Advice), You will then be asked to input additional
            information for the lawyer to access so that they can engage with
            you as a potential client. This might include your name, email,
            phone, and a description of your legal problem. For document review,
            you have the option to upload your document(s) so that the lawyer
            can provide you with a quotation and deadline. You will then need to
            select a date and time for either a remote call or a proposed
            deadline for the document review.
          </p>
          <div className='flex flex-col items-center justify-center gap-2'>
            <Step1BookingCategoryDummy />
          </div>
        </div>
      </LearnMoreCard>
    </div>
  )
}

export default LearnMorePage
